// extracted by mini-css-extract-plugin
module.exports = {"referralTable":"style__referralTable__Mvhny"};